import { useEffect, useState } from 'react';

export default function SafeImage({ src, alt, className, fallback = null, loading = 'lazy' }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [src]);
  if (!src || broken) return fallback;
  return <img className={className} src={src} alt={alt} loading={loading} onError={() => setBroken(true)} />;
}
